import React from 'react';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
}

export const Loader: React.FC<LoaderProps> = ({ size = 'md', color = 'primary' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  const colorClasses = {
    primary: 'border-primary',
    white: 'border-white',
    gray: 'border-gray-400',
  };

  return (
    <div
      className={`${sizeClasses[size]} ${
        colorClasses[color as keyof typeof colorClasses] || colorClasses.primary
      } border-2 border-t-transparent rounded-full animate-spin`}
    />
  );
};
